import React from "react";
import { IMissionVision } from "../../exports/interfaces";

const MissionVision = (props: { missionVisionData: IMissionVision[] }) => {
  return (
    <>
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-65db93bf elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default"
        data-id="65db93bf"
        data-element_type="section"
        data-settings='{"stretch_section":"section-stretched","background_background":"classNameic","hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
      >
        <div className="elementor-container elementor-column-gap-default">
          <div className="elementor-row">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-26e99dca"
              data-id="26e99dca"
              data-element_type="column"
              data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
            >
              <div className="elementor-column-wrap elementor-element-populated">
                <div className="elementor-widget-wrap">
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-1cb63fda elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="1cb63fda"
                    data-element_type="section"
                    data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
                  >
                    <div className="elementor-container elementor-column-gap-wider">
                      <div
                        className="elementor-row custom-row-element custom-missionvision-row-element"
                        style={{ display: "flex", gap: "55px" }}
                      >
                        <div
                          className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-23623ec2"
                          data-id="23623ec2"
                          data-element_type="column"
                          data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                          style={{ flex: 1 }}
                        >
                          <div className="elementor-column-wrap elementor-element-populated">
                            <div className="elementor-widget-wrap">
                              <div
                                className="elementor-element elementor-element-5c535b3e elementor-invisible elementor-widget elementor-widget-heading"
                                data-id="5c535b3e"
                                data-element_type="widget"
                                data-settings='{"_animation":"fadeInRight","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                data-widget_type="heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <h2 className="elementor-heading-title elementor-size-default">
                                    {props?.missionVisionData[0]?.title}
                                  </h2>
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-6386550d elementor-invisible elementor-widget elementor-widget-text-editor"
                                data-id="6386550d"
                                data-element_type="widget"
                                data-settings='{"_animation":"fadeInRight","_animation_delay":400,"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                data-widget_type="text-editor.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-text-editor elementor-clearfix">
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          props?.missionVisionData[0]
                                            ?.description,
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-23623ec2"
                          data-id="23623ec2"
                          data-element_type="column"
                          data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                          style={{ flex: 1 }}
                        >
                          <div className="elementor-column-wrap elementor-element-populated">
                            <div className="elementor-widget-wrap">
                              <div
                                className="elementor-element elementor-element-5c535b3e elementor-invisible elementor-widget elementor-widget-heading"
                                data-id="5c535b3e"
                                data-element_type="widget"
                                data-settings='{"_animation":"fadeInRight","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                data-widget_type="heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <h2 className="elementor-heading-title elementor-size-default">
                                    {props?.missionVisionData[1]?.title}
                                  </h2>
                                </div>
                              </div>
                              <div
                                className="elementor-element elementor-element-6386550d elementor-invisible elementor-widget elementor-widget-text-editor"
                                data-id="6386550d"
                                data-element_type="widget"
                                data-settings='{"_animation":"fadeInRight","_animation_delay":400,"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                                data-widget_type="text-editor.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-text-editor elementor-clearfix">
                                    <p>
                                      {props?.missionVisionData[1]?.description}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MissionVision;
